import { Record } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import DashboardVideo from "models/interfaces/dashboard-video";

const defaultValues: DashboardVideo =
    RecordUtils.defaultValuesFactory<DashboardVideo>({
        videoCardTitle: "",
        videoIdentifier: "",
        thumbnailUrl: "",
        videoUrl: "",
        videoTitle: "",
        videoDescription: "",
    });

export default class DashboardVideoRecord
    extends Record(defaultValues)
    implements DashboardVideo
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: DashboardVideo) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<DashboardVideo>} values
     */
    public with(values: Partial<DashboardVideo>): DashboardVideoRecord {
        return new DashboardVideoRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
